import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { getIsNotifications } from '../../reducers';
import ClearNotifications from './ClearNotifications';
import Position from './Position';

const useStyles = makeStyles(() => ({
  root: {
    width: 200,
    display: 'flex',
    marginBottom: 16,

    '&.position': {
      '&__right': {
        justifyContent: 'flex-end',
        marginLeft: 'auto',

        '& .clear-notifications-btn': {
          marginRight: 8,
        },
      },
      '&__left': {
        flexDirection: 'row-reverse',

        '& .position-button': {
          '& svg': {
            transform: 'rotate(180deg)',
          },
        },

        '& .clear-notifications-btn': {
          marginLeft: 8,
        },
      },
    },
  },
}));

const SnackBarControl = ({ snackbarPositionToggle = () => {}, position }) => {
  const classes = useStyles();
  const notifications = useSelector(getIsNotifications) || [];
  const isNotifications = notifications && notifications.length ? true : false;

  return (
    <>
      {isNotifications && (
        <div className={`${classes.root} position__${position}`}>
          <ClearNotifications />
          <Position snackbarPositionToggle={snackbarPositionToggle} />
        </div>
      )}
    </>
  );
};

export default SnackBarControl;
